export default __webpack_public_path__ + "a639d37b5c199b51a375f254fe8b201a.png";